import { render } from "./BillingInvoicePage.vue?vue&type=template&id=871bc92e"
import script from "./BillingInvoicePage.vue?vue&type=script&lang=js"
export * from "./BillingInvoicePage.vue?vue&type=script&lang=js"

import "./BillingInvoicePage.vue?vue&type=style&index=0&id=871bc92e&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__